import { NumberField, Schema } from "lego-gui-lib/lib";
import { mainStore, api } from "../../../core/mainStore";
import i18next from "i18next";
import { ReportSubscriptionFK } from "../schema";
import { Auth } from "../../../core/model/auth";
import {
  queryParamDtoStrategy,
  queryParamParentChangeStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";
import { ReportsDataSource } from "./ReportsDataSource";
import { MonthField } from "../../../common/DatePickerMonthsOnlyComponent";
import { CustomDateField } from "../../../common/DatePickerComponent";

// @ts-ignore
const t = (...args: unknown[]): string => () => i18next.t(...args);

export const ReportsSchema = new Schema({
  fields: [
    {
      name: "reportSubscriptionRef",
      title: t("hns:reportSubscription:domain"),
      type: ReportSubscriptionFK
    },
    {
      name: "reportDate",
      type: CustomDateField({ customDateFormat: "yyyy-MM-DD" }),
      title: t("hns:report:reportDate")
    }
  ],
  primaryKey: ["id"],
  defaultSort: { sort: "reportDate", order: "desc" },
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  }
});

export const ReportsSchemaColumns = ReportsSchema.extend({
  reportSubscriptionRef: false
});

export const ReportsMonthlySchemaColumns = ReportsSchemaColumns.extend({
  reportDate: {
    type: MonthField({ customDateFormat: "yyyy-MM" })
  }
});

mainStore.report = ReportsDataSource.create({
  parent: mainStore.reportSubscription.oneDataSource,
  parentChangedStrategy: queryParamParentChangeStrategy(
    "id",
    "reportSubscriptionRef"
  ),
  dtoStrategy: queryParamDtoStrategy("id", "reportSubscriptionRef"),
  api: api,
  name: "report",
  schema: ReportsSchema,
  url: "/reports",
  commons: mainStore.commons
});

mainStore.reportMonthly = ReportsDataSource.create({
  parent: mainStore.reportSubscription.oneDataSource,
  parentChangedStrategy: queryParamParentChangeStrategy(
    "id",
    "reportSubscriptionRef"
  ),
  dtoStrategy: queryParamDtoStrategy("id", "reportSubscriptionRef"),
  api: api,
  name: "reportsMonthly",
  schema: ReportsSchema,
  url: "/reports/monthly",
  commons: mainStore.commons
});
